module.exports = __webpack_public_path__ + "img/product3.fa276137.png";